export default [{
  path: '/device/admin',
  name: 'DiveceAdmin',
  component: () => import('@/views/device/DeviceAdmin')
}
]
